export default __webpack_public_path__ + "static/media/icon-voice-outbound.7b898df1.svg";